<template>
  <div class="account-ipt">
    <div class="left-part short-input">
      <input class="input" :class="{'error':errMsgShow}" placeholder="验证码" maxlength="6" v-model="verifyCode" v-on:blur="mobileCodeBlur" v-on:focus="mobileCodeFocus"/>
    </div>
    <div class="right-part">
      <div class="btn-code">
        <div class="btn active" v-show="codeBtnState==CONF.mobileCodeState.enable&&sendMsgs"  @click="showImgCode()">{{CONF.mobileCodeTxt.timeout}}</div>
        <div class="btn active" v-show="codeBtnState==CONF.mobileCodeState.enable&&!sendMsgs" @click="showImgCode()">{{CONF.mobileCodeTxt.enable}}</div>
        <div class="btn disable" v-show="codeBtnState==CONF.mobileCodeState.disable">{{CONF.mobileCodeTxt.disable}}</div>
        <div class="btn disable" v-show="codeBtnState==CONF.mobileCodeState.timeout">{{CONF.mobileCodeTxt.timeout}}({{timer}}s)</div>
      </div>
    </div>
    <div class="msg-box" v-show="errMsgShow&&!isMobile">
      <div class="icon"></div>
      <div class="text color-msg font-size12">{{errMsg}}</div>
    </div>
  </div>
</template>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default{
    name: 'mobileCode',
    props: ['mobileCodeBtnState', 'imgCode', 'inputType', 'codeErrData', 'sendMsg', 'sendMsgTimer'],
    data () {
      return {
        CONF: CONF,
        errMsgShow: false,
        errMsg: '',
        timer: 60,
        timeOutInter: null,
        verifyCode: '',
        codeBtnState: CONF.mobileCodeState.disable,
        isMobile: false,
        sendMsgs: false
      }
    },
    watch: {
      sendMsgTimer () {
        this.verifyCode = ''
        this.errMsgShow = false
      },
      sendMsg (newValue) {
        this.sendMsgs = newValue
      },
      codeErrData (newValue) {
        this.showErrMsg(newValue.errMsg)
      },
      mobileCodeBtnState (newValue) {
        this.codeBtnState = newValue
        if (newValue === CONF.mobileCodeState.timeout) {
          var that = this
          that.timer = 60
          that.timeOutInter = setInterval(function () {
            if (that.timer === 1) {
              clearInterval(that.timeOutInter)
              that.$emit('mobileCodeBtnEnable')
            }
            that.timer--
          }, 1000)
        }
      },
      verifyCode (newValue) {
        var that = this
        that.$emit('mobileCodeSuccess', newValue)
      }
    },
    created () {
      this.isMobile = server.isMobile()
    },
    methods: {
      showImgCode () {
        if (this.inputType === CONF.inputType.mobile) {
          this.$emit('showImgCode')
        } else {
          this.sendResetMsg()
        }
      },
      mobileCodeBlur () {
        if (this.verifyCode.length === 0) {
          return
        }
        if (!CONF.reg.mobileCode.test(this.verifyCode)) {
          this.showErrMsg(CONF.errorMsg.format.mobileCode)
        } else {
          this.errMsgShow = false
        }
      },
      mobileCodeFocus () {
        this.errMsgShow = false
      },
      sendResetMsg () {
        let that = this
        if (that.imgCode.length !== 4) return
        this.codeBtnState = CONF.mobileCodeState.disable
        server.appServices(this, CONF.APIList.resetpwdSendMsg, {imgcode: that.imgCode}).then(res => {
          if (res.status === CONF.errCode.success.code) {
            that.errMsgShow = false
            that.verifyCode = ''
            that.errmsgShow = false
            that.mobileCodeSendSuccess()
            that.sendMsgs = true
          } else {
            this.codeBtnState = CONF.mobileCodeState.enable
            that.$emit('mobileCodeSendFail', res.status)
          }
        })
      },
      // 倒计时开启
      mobileCodeSendSuccess () {
        var that = this
        that.codeBtnState = CONF.mobileCodeState.timeout
        that.timer = 60
        that.timeOutInter = setInterval(function () {
          if (that.timer === 1) {
            clearInterval(that.timeOutInter)
            that.mobileCodeBtnEnable()
          }
          that.timer--
        }, 1000)
      },
// 倒计时完成
      mobileCodeBtnEnable () {
        if (this.imgCode.length > 0) {
          this.codeBtnState = CONF.mobileCodeState.enable
        } else {
          this.codeBtnState = CONF.mobileCodeState.disable
        }
      },
      showErrMsg (msg) {
        if (this.isMobile) {
          this.$toast({toastMsg: CONF.errorMsg.format.mobileCode})
        }
        this.errMsgShow = true
        this.errMsg = msg
      }
    }
  }
</script>



// WEBPACK FOOTER //
// mobileCode.vue?1cf0d584